import moment from 'moment';

export default class Transfer {
  constructor({
    rowNum,
    id,
    userId,
    record,
    recNum,
    recFrm,
    recTo,
    amount,
    balance,
    createdAt
  }) {
    this.rowNum = rowNum || null;
    this.id = id;
    this.userId = userId;
    this.record = record;
    this.recNum = recNum;
    this.recFrm = recFrm;
    this.recTo = recTo;
    this.amount = amount;
    this.balance = balance;
    this.createdAt = createdAt;
    this.expand();
  }

  expand() {
    let createdAtFormatted = null;

    if (moment(this.createdAt).isValid()) {
      createdAtFormatted = moment(this.createdAt).from();
    } else {
      createdAtFormatted = null;
    }
    this.createdAtFormatted = createdAtFormatted;
  }

}
